import { React } from 'react';
import { Container, Stack, Button } from 'react-bootstrap';
import { InterventionTypeList } from './InterventionTypeList/InterventionTypeList';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
export function InterventionTypeManagement() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const handleNewInterventionType = () => {
        navigate('/interventionTypeManagement/newInterventionType');
    };
    return (
        <Container fluid className="px-5" style={{ maxWidth: '1280px' }}>
            <Stack direction="horizontal" gap={3} className="mt-4 justify-content-between">
                <h2>{t('it.Types')}</h2>
                <Button type="button" variant="dark" onClick={handleNewInterventionType}>{t('it.New')}</Button>
            </Stack>
            <InterventionTypeList />
        </Container>
    );
}